module.exports = __webpack_public_path__ + "static/media/hs_11.f36b6c76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_11.jpg
// module id = 5942
// module chunks = 0